import useToastContext from "../context/useToastContext";

export default useDispatchToast;

function useDispatchToast() {
  const dispatch = useToastContext();
  return dispatch;
}
